<template>
  <v-app-bar color="primary" dark app>
    <v-toolbar-items>
      <v-btn
        icon
        @click="handleBack()"
      >
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
    </v-toolbar-items>

    <v-spacer></v-spacer>

    <v-toolbar-items>
      <v-menu offset-y origin="center center" transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon slot="activator" v-on="on">
            <v-icon>mdi-help</v-icon>
          </v-btn>
        </template>
        <v-list class="pa-0">
          <v-list-item
            v-for="(item, index) in helpMenus"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            @click="item.click"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="index"
          >
            <v-list-item-action v-if="item.icon" class="mr-4">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>

    <v-dialog
      v-model="dialogSupport"
      max-width="400px"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>
            Request Support
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              @click="dialogSupport = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container class="subtitle-1">
            <div class="mb-2">For support please contact X-zam Labs&reg;:<br /></div>
            <v-list dense>
              <v-list-item-group>
                <v-list-item @click="handleSupportCall()">
                  <v-list-item-icon>
                    <v-icon>mdi-phone</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    (305) 914-1500
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="handleSupportEmail()">
                  <v-list-item-icon>
                    <v-icon>mdi-email</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    info@labonlocale.com
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            @click="dialogSupport = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>

export default {
  name: 'AppToolbarNewUser',
  components: {},
  data() {
    return {
      helpMenus: [
        {
          icon: 'mdi-face-agent',
          href: '#',
          title: 'Support',
          click: this.handleSupport
        },
        {
          icon: 'mdi-book-open-outline',
          href: '#',
          title: 'Manual',
          click: this.handleManual
        },
      ],
      dialogSupport: false,
    }
  },

  computed: {},

  methods: {
    handleBack() {
      this.$router.push('/login')
    },

    handleSupport() {
      this.dialogSupport = true
    },
    
    handleSupportCall() {
      window.open("tel:+1800229933")
    },

    handleSupportEmail() {
      window.open("mailto:info@labonlocale.com")
    },

    handleManual() {
      window.open("http://www.labonlocale.com/portable-manual/")
    },
  },

  created() {}
}
</script>

<style lang="sass" scoped></style>
